import p from 'page';

import { store } from './routerStore';
import { currentRoute } from './routerState';


class Router {

  /* router.constructor */
	constructor() {
		this._router = p;
    this._layouts = undefined;
    this._views = undefined;
    this._guards = undefined;
    this._routesCache = {};
    this._loader = {
      previous: [],
      current: [],
      components: [],
    };
    this._records = {};
	}

  /* router._toggle */
  _toggle(routeObject) {
    const loader = this._loader;
    loader.components = [];
    loader.previous = loader.current;
    loader.current = [ ...this._routesCache[routeObject.route].views ];
    let i = 0;
    let update = false;
    loader.current.forEach(
      view => {
        let component = null;
        if (loader.previous[i] === undefined) {
          update = true;
          component = loadComponent(view);
        }
        else {
          if (!update && loader.previous[i] !== view)
            update = true;
          if (update)
            component = loadComponent(view);
        }
        loader.components.push({
          update: update,
          component: component,
        });
        i++;
      }
    );
    currentRoute.next(
      routeObject,
      {
        meta: this._routesCache[routeObject.route].meta,
        parentRoute: this._routesCache[routeObject.route].parent
      }
    );
  }

  /* router._component */
  _component(depth) {
    return this._loader.components[depth];
  }
  
  /* router.init */
  init({
    routes,
    layouts = {},
    views = {},
    guards = [],
  }) {
    this._layouts = layouts;
    this._views = views;
    this._guards = guards;
    routes.forEach(route => parseRoute(route));
    this._router.start({
      decodeURLComponents: false,
    });
  }

  /* router.go */
  go(path, records) {
    if (records)
      this._records = Object.assign(this._records, records);
    this._router(path);
  }
  
  /* router.push */
  push(path) {
    history.pushState({ path: path }, '', path);
  }
  
  /* record */
  record(key, def, del) {
    let res;
    if (key in this._records) {
      res = this._records[key];
      if (del)
        delete this._records[key];
    }
	else {
		res = def;
	}
    return res;
  }

  /* router.trail */
  trail(path, home) {
    const tr = [];
    this._trail(tr, path);
    if (home && path != home && this._routesCache[home]) {
      const r = this._routesCache[home];
      tr.unshift({
        path: home,
        name: r.meta && r.meta.name ? r.meta.name : '',
      });
    }
    return tr;
  }
  
  /* router._trail */
  _trail(tr, path) {
    if (this._routesCache[path]) {
      const r = this._routesCache[path];
      tr.unshift({
        path: path,
        name: r.meta && r.meta.name ? r.meta.name : '',
      });
      if (r.parent)
        this._trail(tr, r.parent);
    }
  }

};


/* router */
const router = new Router;


/* loadComponent */
async function loadComponent(view) {
  return (await view()).default;
}


/* parseRoute */
function parseRoute(route, path = '', layout = '', views = []) {
  if (route.path) {
    const _path = path + route.path;
    const _layout = route.layout || route.layout === '' ? route.layout : layout;
    const _views = [ ...views ];
    const _guards = [ ...router._guards ];
    if (route.component)
      _views.push(router._views[route.component]);
    if (route._guard)
      _guards.push(route._guard);
    router._routesCache[_path] = {
      parent: path,
      meta: route.meta,
      views: _layout ? [ router._layouts[_layout], ..._views ] : [ ..._views ],
    };
    if (route.children)
      route.children.forEach(child => parseRoute(child, _path, _layout, _views));
    // routes
    if (route.redirect) {
      // redirect
      router._router(
        _path,
        route.redirect
      );
    }
    else {
      // route
      router._router(
        _path,
        /* **** */
        (ctx, next) => {
          const _rt = ctx.routePath.replace(/\/+$/, '');
          store.pushRoute({
            route: _rt === '*' || _rt === '(.*)' ? '*' : _rt,
            urn: ctx.path.replace(/\/+/, '/').replace(/\/\?/, '?').replace(/\/$/, ''),
            path: ctx.pathname.replace(/\/+$/, ''),
            params: JSON.parse(JSON.stringify(ctx.params)),
            query: ctx.querystring.split('&').reduce((query, param) => {
              const [ key, value ] = param.split('=');
              if (key)
                query[key] = decodeURIComponent(value);
              return query;
            }, {}),
          });
          next();
        },
        /* **** */
        ..._guards.map(
          guard => (ctx, next) => {
            guard(store.getRoute(), store.getRoute(1), next);
          }
        ),
        /* **** */
        () => {
          router._toggle(store.getRoute());
        },
      );
    }
  }
}


export default router;
